import { useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { KBHeader } from "./KBHeader";
import { Sidebar } from "@/components/layout/Sidebar";
import { KBSearchCommand } from "./KBSearchCommand";

export function KBLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchParams] = useSearchParams();
  const selectedCategory = searchParams.get("category");

  const handleCategorySelect = (categorySlug: string | null) => {
    // This will be handled by the Link navigation in mobile sidebar
    // Desktop sidebar already handles this via Link components
  };

  return (
    <div className="min-h-screen bg-background">
      {/* KB Header */}
      <KBHeader
        onSearchClick={() => setSearchOpen(true)}
        onMenuClick={() => setMobileMenuOpen(true)}
      />

      <div className="flex">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block">
          <Sidebar />
        </div>

        {/* Mobile Sidebar Overlay */}
        {mobileMenuOpen && (
          <>
            <div
              className="fixed inset-0 bg-black/40 z-40 lg:hidden"
              onClick={() => setMobileMenuOpen(false)}
            />
            <div className="fixed top-16 left-0 z-50 lg:hidden">
              <Sidebar />
            </div>
          </>
        )}

        {/* Main Content */}
        <main className="flex-1 p-6 lg:p-10 max-w-6xl min-h-[calc(100vh-4rem)]">
          <Outlet />
        </main>
      </div>

      {/* Global Search */}
      <KBSearchCommand
        isOpen={searchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </div>
  );
}